export const getGlobalConfigElement = () => document.body.querySelector('roche-global-config') as HTMLElement;
